import React from 'react';
import Container from '@/components/Container';
import Typography from '@mui/material/Typography';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import { Autocomplete, Chip, MenuItem, TextField } from '@mui/material';
import { DimuOwner } from '@/declarations/models/DimuOwner';

interface MuseumCollectionsProps {
  blockPath: string;
  tComponents: (key: string) => string;
  allDimuOwners: DimuOwner[];
  selectedOwners: DimuOwner[];
  getOptionLabel: (owner: DimuOwner) => string;
  handleOwnerCodesChanged: (owners: DimuOwner[]) => void;
  autocompleteItemStyle: (selected: boolean) => object;
  filterEnabled: boolean;
}

const FilterMuseumCollections: React.FC<MuseumCollectionsProps> = ({
  blockPath,
  tComponents,
  allDimuOwners,
  selectedOwners,
  getOptionLabel,
  handleOwnerCodesChanged,
  autocompleteItemStyle,
  filterEnabled,
}) => (
  <Container fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.MuseumsCollectionsTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: '400px', display: 'flex', alignItems: 'end' }}>
          <SwitchInput
            path={`${blockPath}.useOwnerCodesAsOuterRestriction`}
            label={tComponents('DMFilterSearch.ItemsRestriction')}
          />
          <div style={{ width: '180px' }}>
            <SwitchInput
              path={`${blockPath}.userCanFilterOwnerCodes`}
              label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
            />
          </div>
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <Autocomplete
        multiple
        options={allDimuOwners}
        getOptionLabel={getOptionLabel}
        value={selectedOwners}
        size='small'
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option.identifier} style={autocompleteItemStyle(selected)}>
            {getOptionLabel(option)}
          </li>
        )}
        fullWidth
        disableCloseOnSelect
        isOptionEqualToValue={(o, v) => o.identifier === v.identifier}
        renderInput={(params) => <TextField {...params} label={tComponents('DMFilterSearch.OwnerCodesLabel')} />}
        onChange={(_, v) => handleOwnerCodesChanged(v)}
        renderValue={(value: DimuOwner[], getItemProps) =>
          value.map((option: DimuOwner, index: number) => (
            <Chip size='small' {...getItemProps({ index })} key={option.identifier} label={option.identifier} />
          ))
        }
      />
      {filterEnabled && (
        <div style={{ width: '30%', paddingRight: '5px' }}>
          <TextInput
            path={`${blockPath}.ownerCodesDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.OwnerCodesDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterMuseumCollections;
